/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./resource-uploader.vue?vue&type=template&id=342c834e&scoped=true&"
import script from "./resource-uploader.vue?vue&type=script&lang=js&"
export * from "./resource-uploader.vue?vue&type=script&lang=js&"
import style0 from "./resource-uploader.vue?vue&type=style&index=0&id=342c834e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c834e",
  null
  
)

export default component.exports